import { ECPDEntrySource, type TPikLandingChannel } from 'shared/types/redux/cpd';

import { ETabs } from 'shared/types/redux/tabs';

export function getCPDPikLandingChannelByCurrentTab(
  currentTab: ETabs,
  source: ECPDEntrySource,
): TPikLandingChannel | null {
  const sourceSuffix = source === ECPDEntrySource.Modal ? '_popup' : '_banner';

  if (currentTab === ETabs.Agencies) {
    return `trap_listing_agencies${sourceSuffix}`;
  }

  if (currentTab === ETabs.Realtors) {
    return `trap_listing_agents${sourceSuffix}`;
  }

  return null;
}
